import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

const LABEL_UOM_CHECK = ' (';

@Pipe({ name: 'labelParser' })
export class LabelParserPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    let result: string[] = value.includes(LABEL_UOM_CHECK) ? value.split(LABEL_UOM_CHECK) : [value];

    const htmlResult =
      Array.isArray(result) && result.length > 1
        ? `<span class="value">${result[0]}</span> <span class="uom">(${result[1]}</span>`
        : `<span>${result[0]}</span>`;
    return this.sanitizer.sanitize(SecurityContext.HTML, htmlResult);
  }
}
